/**
 * Helpers de dataLayer espelhando os utilitários da garagem
 * (`helpers/utils.js` + `hoc/withAdobeLaunch/utils.jsx`) usados pelo HOC
 * `withAdobeLaunch`. Mantemos a mesma lógica para que o objDataLayer do my-ads
 * tenha estrutura idêntica à da garagem.
 */

// Faixa Unicode de marcas diacríticas combinantes (U+0300–U+036F). Construída
// via escapes para não embutir caracteres combinantes literais no fonte.
const COMBINING_MARKS = `${String.fromCharCode(0x0300)}-${String.fromCharCode(0x036f)}`;

/** Lê um parâmetro da query string da URL atual (idcmp, icid, lkid, etc.). */
const getQueryStringParameter = (parameterName: string, url?: string): string | undefined => {
	if (typeof window === 'undefined') return undefined;
	const target = url ?? window.location.href;
	const escaped = parameterName.replace(/[[\]]/g, '\\$&');
	const regex = new RegExp(`[?&]${escaped}(=([^&#]*)|&|#|$)`);
	const results = regex.exec(target);
	if (!results || !results[2]) return undefined;
	return results[2];
};

/** Normaliza texto para slug minúsculo sem acentos (igual `sanitizeString` da garagem). */
const sanitizeString = (value?: string | null): string | undefined => {
	if (!value) return undefined;
	return value
		.toString()
		.normalize('NFD')
		.replace(new RegExp(`[${COMBINING_MARKS}](?=\\B)|([^\\w-](?=\\B))`), '')
		.trim()
		.split(' ')
		.join('-')
		.toLowerCase()
		.replace(new RegExp(`[${COMBINING_MARKS}]|([^\\w-])`, 'g'), '');
};

/**
 * Constrói `pageNameTier1/2/3...` a partir dos segmentos finais do pageName
 * (igual `buildTier` da garagem). Recebe os segmentos já fatiados.
 */
const buildTier = (segments: string[]): Record<string, string> =>
	segments.reduce<Record<string, string>>((acc, segment, index) => {
		acc[`pageNameTier${index + 1}`] = segment;
		return acc;
	}, {});

export { getQueryStringParameter, sanitizeString, buildTier };
